

export default function FAQList({ faqs, onEdit, onDelete, onReorder }) {
  const handleMoveUp = (index) => {
    if (index > 0) {
      onReorder(index, index - 1);
    }
  };

  const handleMoveDown = (index) => {
    if (index < faqs.length - 1) {
      onReorder(index, index + 1);
    }
  };

  if (faqs.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 text-center py-12">
        <i className="ri-question-line text-5xl text-gray-300 mb-4"></i>
        <p className="text-gray-500 text-lg">No FAQs yet</p>
        <p className="text-gray-400 text-sm mt-1">Click "Add FAQ" to create your first question</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {/* Desktop Table View */}
      <div className="hidden md:block bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  Order
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  Question
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  Answer
                </th>
                <th className="px-6 py-4 text-right text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {faqs.map((faq, index) => (
                <tr key={faq.id} className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-medium text-gray-900">#{index + 1}</span>
                      <div className="flex flex-col gap-1">
                        <button
                          onClick={() => handleMoveUp(index)}
                          disabled={index === 0}
                          className={`w-6 h-6 flex items-center justify-center rounded hover:bg-gray-200 transition-colors ${
                            index === 0 ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'
                          }`}
                        >
                          <i className="ri-arrow-up-s-line text-gray-600"></i>
                        </button>
                        <button
                          onClick={() => handleMoveDown(index)}
                          disabled={index === faqs.length - 1}
                          className={`w-6 h-6 flex items-center justify-center rounded hover:bg-gray-200 transition-colors ${
                            index === faqs.length - 1 ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'
                          }`}
                        >
                          <i className="ri-arrow-down-s-line text-gray-600"></i>
                        </button>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <p className="text-sm font-medium text-gray-900 line-clamp-2">
                      {faq.question}
                    </p>
                  </td>
                  <td className="px-6 py-4">
                    <p className="text-sm text-gray-600 line-clamp-2">
                      {faq.answer}
                    </p>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center justify-end gap-2">
                      <button
                        onClick={() => onEdit(faq)}
                        className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
                        title="Edit FAQ"
                      >
                        <i className="ri-edit-line text-gray-600"></i>
                      </button>
                      <button
                        onClick={() => onDelete(faq)}
                        className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-red-50 transition-colors cursor-pointer"
                        title="Delete FAQ"
                      >
                        <i className="ri-delete-bin-line text-red-600"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Mobile Card View */}
      <div className="md:hidden space-y-4">
        {faqs.map((faq, index) => (
          <div key={faq.id} className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
            <div className="flex items-start justify-between gap-3 mb-3">
              <div className="flex items-center gap-2">
                <span className="text-sm font-bold text-[#EF579A]">#{index + 1}</span>
                <div className="flex gap-1">
                  <button
                    onClick={() => handleMoveUp(index)}
                    disabled={index === 0}
                    className={`w-7 h-7 flex items-center justify-center rounded bg-gray-100 hover:bg-gray-200 transition-colors ${
                      index === 0 ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'
                    }`}
                  >
                    <i className="ri-arrow-up-s-line text-gray-600"></i>
                  </button>
                  <button
                    onClick={() => handleMoveDown(index)}
                    disabled={index === faqs.length - 1}
                    className={`w-7 h-7 flex items-center justify-center rounded bg-gray-100 hover:bg-gray-200 transition-colors ${
                      index === faqs.length - 1 ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-gray-600"></i>
                  </button>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => onEdit(faq)}
                  className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors cursor-pointer"
                  title="Edit FAQ"
                >
                  <i className="ri-edit-line text-gray-600"></i>
                </button>
                <button
                  onClick={() => onDelete(faq)}
                  className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-50 hover:bg-red-100 transition-colors cursor-pointer"
                  title="Delete FAQ"
                >
                  <i className="ri-delete-bin-line text-red-600"></i>
                </button>
              </div>
            </div>
            <div className="space-y-2">
              <div>
                <p className="text-xs font-semibold text-gray-500 uppercase mb-1">Question</p>
                <p className="text-sm font-medium text-gray-900">{faq.question}</p>
              </div>
              <div>
                <p className="text-xs font-semibold text-gray-500 uppercase mb-1">Answer</p>
                <p className="text-sm text-gray-600 line-clamp-3">{faq.answer}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
